import { CUSTOMER_STORAGE_BASE_FOLDER_URL } from "@features/CustomerStorage/constants";
import { Skeleton } from "@components/Skeleton/Skeleton";
import { isNullOrUndefined } from "@utils/common";
import { CustomerStorageItemListSkeleton } from "../CustomerStorageItemListSkeleton/CustomerStorageItemListSkeleton";

interface ICustomerStorageSkeletonProps {
  currentFolderUrl?: string;
}

export const CustomerStorageSkeleton: React.FC<
  ICustomerStorageSkeletonProps
> = ({ currentFolderUrl }) => {
  const isBaseFolder =
    isNullOrUndefined(currentFolderUrl) ||
    currentFolderUrl === CUSTOMER_STORAGE_BASE_FOLDER_URL;

  return (
    <>
      {isBaseFolder && (
        <>
          <div className="relative mx-4 mb-5 rounded-2xl border border-grey-light bg-base-white p-6 md:mx-0">
            <Skeleton className="h-[120px] w-full" />
          </div>
          <div className="relative h-44 w-full overflow-x-auto bg-base-white px-4 scrollbar-hide md:px-0">
            <div className="absolute whitespace-nowrap">
              {Array(4)
                .fill(0)
                .map((_, index) => (
                  <div
                    key={index}
                    className="relative mr-4 inline-block h-36 min-w-64 rounded-2xl border border-grey-light p-6"
                  >
                    <Skeleton className="h-full w-full" />
                  </div>
                ))}
            </div>
          </div>
        </>
      )}
      <div className="mb-5 divide-y divide-grey-light border-b border-t border-grey-light bg-base-white md:rounded-xl md:border">
        <div className="flex items-center justify-between gap-3 p-4 text-lg font-medium md:text-base">
          <Skeleton className="w-[300px] text-lg" />
          <div className="flex-1" />
          <Skeleton variant="rounded" className="w-12 text-lg md:w-[165px]" />
          <Skeleton variant="rounded" className="w-12 text-lg md:w-[125px]" />
        </div>
        <CustomerStorageItemListSkeleton />
      </div>
    </>
  );
};
